export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10119.203e6ff0.jpg";